const addressFormatter = (address) => {
  const keys = ['name', 'address1', 'address2', 'address3', 'address4', 'address5', 'postcode'];
  const addressArray = keys.map((key) => address[key]).filter((a) => a);
  return addressArray.join(', ');
};

export default addressFormatter;
